import { ActivityType } from 'lib-shared-legacy-types';

export const automatedActivityTypes: ActivityType[] = [
  'CONVERSATION_CREATED_BY_CUSTOMER',
  'CONVERSATION_CREATED_BY_AGENT',
  'CONVERSATION_OFFERED',
  'CONVERSATION_CLOSED',
  'CONVERSATION_PENDING',
  'CONVERSATION_RESERVED',
];
